export const OWNERSHIP_MIN_ZOOM = 14;
